class ApiForms {
    static init() {
        ApiForms.#addDecorativeElements();
        const $colorPicker = $('.color-picker');
        const $selectPickers = $('.selectpickers');
        const $dateTimePicker = $('.date-time-picker');
        const $timePicker = $('.time-picker');
        const $datePicker = $('.date-picker');
        const $rootWizard = $('#rootwizard');
        const $htmlEditor = $('.html-editor');
        const $inputSlider = $('.input-slider');
        const $inputSliderRange = $('.input-slider-range');
        const $inputSliderValues = $('.input-slider-values');
        const $inputMask = $('.input-mask');
        const $tagSelect = $('.tag-select');
        const $autoSize = $('.auto-size');

        if ($colorPicker.length) {ApiForms.colorPicker($colorPicker);}
        if ($selectPickers.length) {ApiForms.customSelect($selectPickers);}
        if ($dateTimePicker.length) {ApiForms.datePickerTimeDate($dateTimePicker);}
        if ($timePicker.length) {ApiForms.datePickerTime($timePicker);}
        if ($datePicker.length) {ApiForms.datePickerDate($datePicker);}
        if ($rootWizard.length) {ApiForms.formWizard($rootWizard);}
        if ($htmlEditor.length) {ApiForms.htmlEditor($htmlEditor);}
        if ($inputSlider.length) {ApiForms.inputSlider($inputSlider);}
        if ($inputSliderRange.length) {ApiForms.#inputSliderRange($inputSliderRange);}
        if ($inputSliderValues.length) {ApiForms.#inputSliderValue($inputSliderValues);}
        if ($inputMask.length) {ApiForms.inputMask($inputMask);}
        if ($tagSelect.length) {ApiForms.tagSelect($tagSelect);}
        if ($autoSize.length) {ApiForms.textareaAutosize($autoSize);}
        if ($('.add-template').length) {ApiForms.#addSubForm();}
    }

    static colorPicker($element) {
        //Color Picker
        if ($element.length) {
            $element.each(function () {
                $element.each(function () {
                    const colorOutput = $(this).closest('.cp-container').find('.cp-value');
                    $(this).farbtastic(colorOutput);
                });
            });
        }
    }

    static customSelect($element) {
        //Custom Select
        if ($element.length) {
            $element.selectpicker();
        }
    }

    static datePickerTimeDate($element) {
        //Date Time Picker
        if ($element.length) {
            $element.each(function() {
                const $this = $(this);

                if ($this.is("[date-firstdate]")) {
                    $element.datetimepicker({
                        format: 'YYYY-MM-DD HH:mm',
                        minDate : $this.attr('date-firstdate')
                    });
                } else {
                    $element.datetimepicker({
                        format: 'YYYY-MM-DD HH:mm'
                    });
                }
            });
        }
    }

    static datePickerTime($element) {
        //Time
        if ($element.length) {
            $element.datetimepicker({
                format: 'LT'
            });
        }
    }

    static datePickerDate($element) {
        //Date
        if ($element.length) {
            $element.datetimepicker({
                format: 'YYYY-MM-DD'
            });
        }
    }

    static formWizard($element) {
        //Form Wizard
        const $rootWizard = $('#rootwizard');

        if ($element.length) {
            if (typeof $rootWizard.bootstrapWizard === 'function') {
                $rootWizard.bootstrapWizard({
                    tabClass: '.tab-nav',
                    previousSelector: '.navigation a.prev',
                    nextSelector: '.navigation button.next',
                    onTabShow: function (tab, navigation, index) {
                        const $total = navigation.find('li').length;
                        const $current = index + 1;
                        const $percent = ($current / $total) * 100;

                        $rootWizard.find('.bar').css({width: $percent + '%'});

                        // If it's the last tab then hide the last button and show the finish instead
                        if ($current === 1) {
                            $rootWizard.find('.navigation .prev').hide();
                        } else {
                            $rootWizard.find('.navigation .prev').show();
                        }

                        if ($current >= $total) {
                            $rootWizard.find('.navigation .next').hide();
                            $rootWizard.find('.navigation .finish').show();
                        } else {
                            $rootWizard.find('.navigation .next').show();
                            $rootWizard.find('.navigation .finish').hide();
                        }
                    },
                    onTabChange: function (tab, navigation, index) {
                        // return false;
                    }
                });
            }
        }
    }

    static htmlEditor($element) {
        if ($element.length) {
            $element.summernote({
                height: 150
            });
        }
    }

    static inputSlider($element) {
        if ($element.length) {
            $element.each(function () {
                const isStart = $(this).data('is-start');

                $(this).noUiSlider({
                    start: isStart,
                    range: {
                        'min': 0,
                        'max': 100
                    }
                });
            });
        }
    }

    static inputMask($element) {
        //Input Mask
        if ($element.length) {
            $element.mask();
        }
    }

    static tagSelect($element) {
        //Tag Select
        if ($element.length) {
            $element.chosen({
                width: '100%',
                allow_single_deselect: true
            });
        }
    }

    static textareaAutosize($element) {
        //Auto Height Textarea
        if ($element.length) {
            $element.autosize();
        }
    }

    //add additional elements
    static #addDecorativeElements() {
        //Add blue animated border and remove with condition when focus and blur
        if ($('.fg-line')[0]) {
            const $body = $('body');

            $body.on('focus', '.form-control', function () {
                $(this).closest('.fg-line').addClass('fg-toggled');
            });

            $body.on('blur', '.form-control', function () {
                const p = $(this).closest('.form-group');
                const i = p.find('.form-control').val();
                if (p.hasClass('fg-float')) {
                    if (i.length === 0) {
                        $(this).closest('.fg-line').removeClass('fg-toggled');
                    }
                } else {
                    $(this).closest('.fg-line').removeClass('fg-toggled');
                }
            });
        }

        //Add blue border for pre-valued fg-flot text fields
        if ($('.fg-float')[0]) {
            $('.fg-float .form-control').each(function () {
                const i = $(this).val();
                if (i.length !== 0) {
                    $(this).closest('.fg-line').addClass('fg-toggled');
                }
            });
        }
    };

    //Range slider
    static #inputSliderRange($element) {
        if ($element.length) {
            $element.noUiSlider({
                start: [30, 60],
                range: {
                    'min': 0,
                    'max': 100
                },
                connect: true
            });
        }
    };

    //Range slider with value
    static #inputSliderValue($element) {
        if ($element.length) {
            $element.noUiSlider({
                start: [ 45, 80 ],
                connect: true,
                direction: 'rtl',
                behaviour: 'tap-drag',
                range: {
                    'min': 0,
                    'max': 100
                }
            });

            $element.Link('lower').to($('#value-lower'));
            $element.Link('upper').to($('#value-upper'), 'html');
        }
    };


    //add subform based on a template
    static #addSubForm(){
        $('.add-template').on('click', function(e){
            e.preventDefault();
            const template = $(this).attr('template');
            const href = $(this).attr('href');
            $('#'+template).tmpl().appendTo(href);
        });
        $('.subform').on('click', '.delete-template', function(e){
            e.preventDefault();
            $(this).parent().parent().remove();
        });
    };
}
